export const NEXT_LOCALE_COOKIE = 'NEXT_LOCALE';
export const ENECO_SEGMENT_COOKIE = 'ENECO_SEGMENT';
